import { IEntity, ObjectState } from '../interfaces/entity';
import { Category } from './lookup-category';
import { SubjectType } from './subject-type';
import {Template, TEMPLATE_TYPE} from './template';

export interface ILayoutList{
  items: Layout[];
  totalCount: number;
}

export class Layout implements IEntity {
  id: number;
  uid: string;
  subjectTypeId: number;
  categoryId: number;
  layoutTemplates: LayoutTemplate[];
  subjectType: SubjectType;
  category: Category;
  summary: string;

  constructor(layout?)
    {
        layout = layout || {};
        this.id = layout.id;
        this.uid = layout.uid;
        this.subjectTypeId = layout.subjectTypeId || null;
        this.categoryId = layout.categoryId || null;
        this.layoutTemplates = layout.layoutTemplates || [];
        this.subjectType = layout.subjectType;
        this.category = layout.category;
        this.summary = layout.summary;
    }

  getTemplate(type: string): Template{
    let layoutTemplate = this.layoutTemplates.find((x) => (x.template && (x.template.type === type)));
    if (layoutTemplate && layoutTemplate.template) {
      return layoutTemplate.template;
    }
    else{
      layoutTemplate = new LayoutTemplate();
      layoutTemplate.template = new Template(type);
      this.layoutTemplates.push(layoutTemplate);
      return layoutTemplate.template;
    }
  }

  setTemplate(template: Template, type: string){    
    const layoutTemplate = this.layoutTemplates.find((x) => (x.template && (x.template.type === type)));
    if (!layoutTemplate){
      this.addTemplate(template);
    }
    else{
      layoutTemplate.templateId = template.id;
      layoutTemplate.template = template;
    }
  }

  addTemplate(template: Template): LayoutTemplate{
    const layoutTemplate = new LayoutTemplate();
    layoutTemplate.layoutId = this.id;
    layoutTemplate.templateId = template.id;
    layoutTemplate.template = template;
    this.layoutTemplates.push(layoutTemplate);
    return layoutTemplate;
  }

  get editTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.EDIT);
  }

  set editTemplate(val: Template){
    this.setTemplate(val, TEMPLATE_TYPE.EDIT);
  }

  get cardTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.CARD);
  }

  set cardTemplate(val: Template){
    this.setTemplate(val, TEMPLATE_TYPE.CARD);
  }

  get listTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.LIST);
  }

  set listTemplate(val: Template){
    this.setTemplate(val, TEMPLATE_TYPE.LIST);
  }

  get dashboardTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.DASHBOARD);
  }

  set dashboardTemplate(val: Template){
    this.setTemplate(val, TEMPLATE_TYPE.DASHBOARD);
  }

  get referralDashboardTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.REFERRALDASHBOARD);
  }

  set referralDashboardTemplate(val: Template){
    this.setTemplate(val, TEMPLATE_TYPE.REFERRALDASHBOARD);
  }

  get referralTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.REFERRAL);
  }

  set referralTemplate(val: Template){
    this.setTemplate(val, TEMPLATE_TYPE.REFERRAL);
  }

  get referralCardTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.REFERRALCARD);
  }

  set referralCardTemplate(val: Template){
    this.setTemplate(val, TEMPLATE_TYPE.REFERRALCARD);
  }
}

// tslint:disable-next-line:max-classes-per-file
export class LayoutTemplate implements IEntity{
  id: number;
  uid: string;
  layoutId: number;
  templateId: number;
  template: Template;
  objectState: ObjectState;
}
